import React from 'react';
import { Box, HStack, Icon, Text, Tooltip } from '@televet/kibble-ui';

const LabelPopover = ({ title, description }: { title: string; description: string }): JSX.Element => {
  return (
    <HStack position="relative">
      <Text fontWeight="bold">{title}</Text>
      <Tooltip label={description}>
        <Box cursor="pointer">
          <Icon name="infoCircle" size="xs" variant="subtle" />
        </Box>
      </Tooltip>
    </HStack>
  );
};

export default LabelPopover;
